var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5925C11.3252 3.5925 10.4264 4.05686 9.63453 5.48495L3.57455 16.3849C3.57447 16.3851 3.57464 16.3847 3.57455 16.3849C2.84084 17.7085 2.90312 18.6921 3.25114 19.285C3.59864 19.877 4.42467 20.41 5.93999 20.41H12C12.0482 20.41 12.0956 20.4134 12.142 20.42H18.06C19.5693 20.42 20.3965 19.8876 20.7456 19.2942C21.0947 18.7007 21.1586 17.7177 20.4258 16.3956M20.4258 16.3956L14.3658 5.48557C13.5739 4.05748 12.6748 3.5925 12 3.5925M11.858 22.41H5.93999C3.9853 22.41 2.35133 21.703 1.52633 20.2975C0.701891 18.8929 0.879414 17.1213 1.82542 15.4151L7.88544 4.51505C7.8853 4.51532 7.88559 4.51478 7.88544 4.51505C8.87353 2.7336 10.325 1.5925 12 1.5925C13.675 1.5925 15.1261 2.73287 16.1142 4.51442M16.1142 4.51442L22.1742 15.4244C23.1209 17.132 23.2952 18.9044 22.4694 20.3083C21.6435 21.7124 20.0107 22.42 18.06 22.42H12C11.9518 22.42 11.9044 22.4166 11.858 22.41M12 8C12.5523 8 13 8.44771 13 9V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V9C11 8.44771 11.4477 8 12 8ZM10.9945 17C10.9945 16.4477 11.4422 16 11.9945 16H12.0035C12.5558 16 13.0035 16.4477 13.0035 17C13.0035 17.5523 12.5558 18 12.0035 18H11.9945C11.4422 18 10.9945 17.5523 10.9945 17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.30255ec88ef5b5f439f6ef904345d990.svg";
export { ForwardRef as ReactComponent };